import React, { useState } from 'react';
import { Job, JobFormData } from '../../types/models';
import { JobService } from '../../services/jobService';

interface JobFormProps {
  job?: Job;
  onSuccess: () => void;
  onCancel: () => void;
}

export const JobForm: React.FC<JobFormProps> = ({ job, onSuccess, onCancel }) => {
  const [formData, setFormData] = useState<JobFormData>({
    name: job?.name || '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      let response;
      if (job) {
        // Обновление
        response = await JobService.update(job.id, { ...formData, id: job.id });
      } else {
        // Создание
        response = await JobService.create(formData);
      }

      if (response.success) {
        onSuccess();
      } else {
        setError(response.message || 'Ошибка сохранения');
      }
    } catch (err) {
      setError('Произошла ошибка при сохранении');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="modal-overlay">
      <div
        className="modal-content"
        style={{ maxWidth: '600px' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="card" style={{ margin: 0, boxShadow: 'none' }}>
          <h3>{job ? 'Редактирование должности' : 'Создание должности'}</h3>

          {error && (
            <div className="alert alert-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Название должности *</label>
          <input
            type="text"
            name="name"
            className="form-input"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Введите название должности"
          />
        </div>

        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? 'Сохранение...' : (job ? 'Сохранить' : 'Создать')}
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onCancel}
            disabled={loading}
          >
            Отмена
          </button>
        </div>
      </form>
        </div>
      </div>
    </div>
  );
};

